import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowLeft } from 'lucide-react';
import ProductCard from '../components/ProductCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CollectionPage() {
  const { collectionId } = useParams();
  const { t, lang } = useLanguage();
  const [collection, setCollection] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/collections/${collectionId}`)
      .then(r => setCollection(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [collectionId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center">
        <p className="text-[#6B655F] font-light">{t('common.loading')}</p>
      </div>
    );
  }

  if (!collection) {
    return (
      <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center">
        <p className="text-[#6B655F]">{lang === 'id' ? 'Koleksi tidak ditemukan' : 'Collection not found'}</p>
      </div>
    );
  }

  const name = lang === 'id' ? collection.name_id : collection.name_en;
  const desc = lang === 'id' ? collection.description_id : collection.description_en;

  return (
    <div className="min-h-screen bg-[#FAFAF7]" data-testid="collection-page">
      {/* Hero */}
      <div className="relative h-72 md:h-96 overflow-hidden">
        <img src={collection.image} alt={name} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2C2A29]/70 via-[#2C2A29]/30 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
          <div className="max-w-7xl mx-auto">
            <Link to="/catalog" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors mb-4 font-light" data-testid="back-to-catalog">
              <ArrowLeft size={16} /> {t('common.back')}
            </Link>
            <h1 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light text-white tracking-tight" data-testid="collection-title">
              {name}
            </h1>
            <p className="mt-3 text-base text-white/70 font-light max-w-lg">{desc}</p>
          </div>
        </div>
      </div>

      {/* Products */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-10">
        {collection.products?.length > 0 ? (
          <>
            <p className="text-sm text-[#6B655F] font-light mb-8">
              {collection.products.length} {lang === 'id' ? 'buket dalam koleksi ini' : 'bouquets in this collection'}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
              {collection.products.map(product => (
                <ProductCard key={product.product_id} product={product} />
              ))}
            </div>
          </>
        ) : (
          <div className="text-center py-10">
            <p className="text-lg text-[#6B655F] font-light">
              {lang === 'id' ? 'Belum ada buket di koleksi ini.' : 'No bouquets in this collection yet.'}
            </p>
            <Link to="/catalog" className="mt-6 inline-block text-sm text-[#C5DB7B] hover:text-[#D4859B] transition-colors font-medium">
              {t('cart.browse')} →
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
